<template>
  <client-only>
    <global-modal
      modal-id="ekycDetailModal"
      :modal-view="kycDetailModal.view"
      @onCloseModal="kycDetailModal.view = false"
    >
      <ekyc-detail
        :title="$t('scenes.ekyc.detail.navigation-title')"
        class="c--shared_ekyc-detail-modal ekyc-detail-modal"
        :identitiesDefault="kycDetailModal.data"
      />
    </global-modal>
  </client-only>
</template>

<script>
  import EkycDetail from '~/components/shared/ekyc-detail.vue'
  import GlobalModal from '~/components/modals/general-modal.vue'

  export default {
    name: 'ekyc-detail-modal',

    components: {
      EkycDetail,
      GlobalModal,
    },

    data() {
      return {
        kycDetailModal: {
          view: false,
          data: {},
        },
      }
    },

    beforeDestroy() {
      this.$root.$off('ekyc-detail-modal')
    },

    created() {
      this.$root.$on('ekyc-detail-modal', (kycItem) => {
        this.kycDetailModal = {
          view: true,
          data: kycItem,
        }
      })
    },
  }
</script>

<style lang="scss">
  #ekycDetailModal {
    .modal-general {
      max-width: 730px;
    }

    .general-item-wrapper.pt-40 {
      padding-top: 0 !important;
    }

    .ekyc-detail-modal {
      padding: 40px;
      @media only screen and (max-width: 768px) {
        padding: 30px;
      }
      @media only screen and (max-width: 575px) {
        padding: 20px;
      }
    }
  }
</style>
